import styled from 'styled-components';
import { colors } from '../../variables';

const getBackground = props => {
	if (props.color === 'white') return '#fff';
	if (props.color === 'blue') return colors.blue.bromma;
	if (props.color === 'dark') return colors.grey.graphite;
	if (props.color === 'digital') return colors.blue.digital;
	if (props.color === 'green') return colors.green.eco;
	if (props.color === 'orange') return colors.orange.spreader;
	if (props.color === 'purple') return colors.purple.normal;
	if (props.color === 'red') return colors.red.warning;
	if (props.color === 'yellow') return colors.yellow.bromma;

	return colors.grey.normal;
};

const getColor = props => {
	if (props.outline) return getBackground(props);
	if (!props.color || props.color === 'white') return colors.grey.graphite;

	return '#fff';
};

const Tag = styled.span`
	display: inline-block;
	padding: ${props => (props.small ? '3px 8px' : '5px 15px')};
	background: ${props =>
		props.outline ? 'transparent' : getBackground(props)};
	border: 1px solid ${props => getBackground(props)};
	color: ${props => getColor(props)};
	border-radius: ${props => (props.small ? '10px' : '20px')};
	line-height: 1;
`;

export default Tag;



// WEBPACK FOOTER //
// ./src/components/Common/Tag/Tag.js